import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { IconModule, LoaderModule, TableConfig, TableModule } from '@michelin/theme';
import { Script } from 'src/app/interfaces/script';
import { ScriptStatus } from 'src/app/interfaces/scriptStatus';
import { UtilService } from 'src/app/util/util.service';
import { ApplicationService } from '../application.service';
import { HistoricScriptModalComponent } from './historic-script-modal/historic-script-modal.component';

@Component({
  selector: 'mic-app-run-script',
  templateUrl: './run-script.component.html',
  styleUrls: ['./run-script.component.scss'],
  imports: [TableModule, MatIcon, MatTooltip, IconModule, LoaderModule]
})
export class RunScriptComponent implements OnInit {
  private readonly applicationService = inject(ApplicationService);
  readonly utilService = inject(UtilService);
  dialog = inject(MatDialog);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() scriptFunction: Script[];
  dataSource = new MatTableDataSource();
  scriptStatus: ScriptStatus;
  scriptId: number;

  ngOnInit(): void {
    if (this.scriptFunction.length !== 0) {
      this.dataSource.data = this.scriptFunction;
      this.cdr.detectChanges();
      this.applicationService.getTheLastScriptStatus(this.scriptFunction[this.scriptFunction.length - 1].id).subscribe((response) => {
        this.scriptStatus = response;
      });
    }
  }

  tableConfig: TableConfig<Script> = {
    onRowExpand: (elm: Script[]) => {
      this.scriptId = elm.find((script) => script.id).id;
    },
    columns: {
      name: { cell: (elm: Script) => elm.name.toString(), header: 'Name' },
      description: { cell: (elm: Script) => elm.description.toString(), header: 'Description', width: '800px' },
      run: { cell: 'Run', header: 'Run', width: '50px' }
    }
  };

  onRunScript(script: Script) {
    this.applicationService.runScript(script).subscribe((response) => {
      // I will get the id of the status
      this.scriptStatus = response;
    });
    const intervalId = setInterval(() => {
      if (this.scriptStatus.status === 'OK') {
        clearInterval(intervalId);
      }
      this.applicationService.getScriptStatus(this.scriptStatus.id).subscribe((response) => {
        this.scriptStatus = response;
      });
    }, 1000);
  }

  onHistoric() {
    this.dialog.open(HistoricScriptModalComponent, {
      width: '800px',
      data: this.scriptId
    });
  }
}
